import { bordColorTheme, nudosGreen300, nudosRed100 } from "styles/styles.constants";

export type SummaryVariant = 'to quote' | 'approved' | 'pending' | 'rejected' | 'orderSummary' | 'cancelled';

export interface ITotalsServiceSummary {
  totalUSD: number;
  total: number;
  currency: string;
}

export enum SERVICE_SUMMARY_VARIANTS {
    TO_QUOTE = 'to quote',
    PENDING = 'pending',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    ORDER_SUMMARY = 'orderSummary',
    CANCELLED = 'cancelled'
}

export enum SERVICE_SUMMARY_VARIANT_TEXT {
    'to quote' = 'Por cotizar',
    'pending' = 'Pendiente de aprobación',
    'approved' = 'Aprobada',
    'rejected' = 'Rechazada',
    'orderSummary' = 'Resumen de la orden',
    'serviceSummary' = 'Resumen del servicio',
    'cancelled' = 'Sin información'
}

export enum SERVICE_SUMMARY_VARIANT_ICON {
    'to quote' = 'alertTriangleWarning',
    'pending' = 'clock',
    'approved' = 'checkCircle',
    'rejected' = 'xSquare',
    'orderSummary' = 'questionCircle'
}

export const ServiceSummaryVariantIconColor: Record<SummaryVariant, string> = {
    'to quote': nudosRed100,
    'pending': bordColorTheme.yellow[200],
    'approved': nudosGreen300,
    'rejected': nudosRed100,
    'orderSummary': nudosGreen300,
    'cancelled': nudosRed100

  };

export interface IEditPricesPermissions {
  read: boolean;
  edit: boolean;
}
